import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUpdateCollectionModerationStatusVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  moderationStatus: Types.ApiModerationStatus;
}>;


export type ApiUpdateCollectionModerationStatus = { updateCollectionModerationStatus: { moderationStatus: Types.ApiModerationStatus } | null };



export const ApiUpdateCollectionModerationStatusDocument = /*#__PURE__*/ `
    mutation UpdateCollectionModerationStatus($id: ID!, $moderationStatus: ModerationStatus!) {
  updateCollectionModerationStatus(id: $id, moderationStatus: $moderationStatus) {
    moderationStatus
  }
}
    `;

export const useUpdateCollectionModerationStatus = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiUpdateCollectionModerationStatus, TError, ApiUpdateCollectionModerationStatusVariables, TContext>) => {
    
    return useMutation<ApiUpdateCollectionModerationStatus, TError, ApiUpdateCollectionModerationStatusVariables, TContext>(
      {
    mutationKey: ['UpdateCollectionModerationStatus'],
    mutationFn: (variables?: ApiUpdateCollectionModerationStatusVariables) => apiFetcher<ApiUpdateCollectionModerationStatus, ApiUpdateCollectionModerationStatusVariables>(ApiUpdateCollectionModerationStatusDocument, variables)(),
    ...options
  }
    )};


useUpdateCollectionModerationStatus.fetcher = (variables: ApiUpdateCollectionModerationStatusVariables, options?: RequestInit['headers']) => apiFetcher<ApiUpdateCollectionModerationStatus, ApiUpdateCollectionModerationStatusVariables>(ApiUpdateCollectionModerationStatusDocument, variables, options);
